import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "AccessRecords/"


function register(route){
  return axios.post(`${host}register`, {
    route: route
  })
    .then(data => {
      return data.data
    })
}

function getStats(from, to){
  return axios.get(`${host}stats`, {
    params: {
      from: from,
      to: to
    }
  })
    .then(data => {
      return data.data
    })
}

function getByIp(from, to, page = 0){
  return axios.get(`${host}byIp`, {
    params: {
      from: from,
      to: to,
      page: page
    }
  })
    .then(data => {
      return data.data
    })
}

function getByUser(from, to, page = 0){
  return axios.get(`${host}byUser`, {
    params: {
      from: from,
      to: to,
      page: page
    }
  })
    .then(data => {
      return data.data
    })
}

export default {
  register,
  getStats,
  getByIp,
  getByUser
}
